import { useEffect } from 'react';
import { message } from 'antd';
import PagesRoot from 'src/pages';
import { AppStateProvider } from 'src/stores';

import styles from './App.module.scss';


function App() {
  useEffect(() => {
    // 配置 message 全局設定，讓它可以在任何地方使用
    message.config({
      top: 100,
      duration: 3,
      maxCount: 3
    });
  }, []);

  return (
    <div className={styles.app}>
      <AppStateProvider>
        <PagesRoot />
      </AppStateProvider>
    </div>
  );
}

export default App;
